import { render, staticRenderFns } from "./ShortcutsMenu.vue?vue&type=template&id=5db44339&scoped=true"
import script from "./ShortcutsMenu.vue?vue&type=script&lang=js"
export * from "./ShortcutsMenu.vue?vue&type=script&lang=js"
import style0 from "./ShortcutsMenu.vue?vue&type=style&index=0&id=5db44339&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db44339",
  null
  
)

export default component.exports